/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorIconPrimary = "#90D4E6";
export const ColorBackgroundPrimary = "#E9F6FA";
export const ColorBackgroundSecondary = "#90D4E6";
export const ComponentsCtaPrimaryTextDefault = "#363432";
export const ComponentsCtaPrimaryIconDefault = "#363432";
export const ComponentsCtaPrimaryBgDefault = "#90D4E6";
export const ComponentsCtaPrimaryBgHover = "#A6DDEB";
export const ComponentsCtaPrimaryBgPressed = "#A6DDEB";
export const ComponentsCtaPrimaryBgFocused = "#BCE5F0";
export const ComponentsCtaPrimaryBorderDefault = "transparent";
export const ComponentsCtaPrimaryBorderHover = "transparent";
export const ComponentsCtaPrimaryBorderPressed = "transparent";
export const ComponentsCtaPrimaryBorderFocus = "transparent";
